module.exports = __webpack_public_path__ + "media/images/ecommerce/wallet-92f938aac1ac3544124f0ace732ff945.svg";